/**
 * pk10动画拖拽框
 * @author: circle 
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { setCookie, getCookie } from '../../helpers/unit';

export default class DragBox extends React.Component {
	
	constructor(props) {
	  super(props);
	}

	//鼠标按下
	mouseDown(event){
		let dome = document.getElementById("dragBox")
		let bodyW = document.documentElement.clientWidth;
		let bodyH = document.documentElement.clientHeight;
		const mouseX = event.pageX;
		const mouseY = event.pageY;
		const boxLeft = dome.offsetLeft;
		const boxTop = dome.offsetTop;
		const boxW = dome.offsetWidth;
		const boxH = dome.offsetHeight;
		event.preventDefault()
		document.onmousemove = function(e){
			let mX = boxLeft + (e.pageX - mouseX);
			let mY = boxTop + (e.pageY - mouseY);

			dome.style.left = mX + "px";

			if(mX+boxW > bodyW-5 || e.pageX > bodyW-5){
				dome.style.left = (bodyW-boxW) + "px";
			}
			if(mX < 0 || e.pageX < 0){
				dome.style.left = "0px";
			}

			dome.style.top = mY + "px";

			if(mY+boxH > bodyH-5 || e.pageY > bodyH-5){
				dome.style.top = (bodyH-boxH-5) + "px";
			}
			if(mY < 0 || e.pageY < 0){
				dome.style.top = "0px";
			}

		}
		document.onmouseup = function(){

			const left = document.getElementById("dragBox").offsetLeft;
			const top = document.getElementById("dragBox").offsetTop;
			setCookie('drag-box-position', left + ',' + top, 30*24*3600);
			document.onmouseup = null;
			document.onmousemove = null;

		}
	}	

	componentDidMount(){
		ReactDOM.findDOMNode( this.refs['main-box'] ).addEventListener('mousedown', this.mouseDown)

		const position = getCookie('drag-box-position');
		if (!position) {return;}
		let dome = document.getElementById("dragBox")
		dome.style.left = Number(_.split(position, ',')[0]) + 'px';
		dome.style.top = Number(_.split(position, ',')[1]) + 'px';
		
	}
	handleClose(){
		const {onClose, onCloseSize} = this.props;
		onClose(false);
		onCloseSize('default');
	}

	render() {
		const {display, text, subTitle, buttons, sizeMode} = this.props;
		return (
			<div className={display ? 'dragBox' : 'hide'} ref="dragBox" id="dragBox" >
				<a className='pointer close' onClick={this.handleClose.bind(this)}></a>
				<div ref='main-box'>
					<h3>
						<span>{text}</span>
						<div className='dragBoxSize'>{subTitle}
							{
								buttons.map((button, index) => <i key={index} className={button.activeKey == sizeMode.className ? 'active drag-button' : 'drag-button'} onClick={button.action} >{button.text}</i> )
							}
						</div>
					</h3>
					<div className='animateBox' ref="animateBox" style={{height: sizeMode.height +'px', width: sizeMode.width + 'px'}}>
						{React.Children.map(this.props.children, (item) => item)}
					</div>
				</div>
			</div>
		)
	}
}